<template>
  <div id="header">
    <div class="header-content">
      <img class="patientList-logo" src="../../assets/LOGO.png" @click="home">
      <div class="patientList-user">
        <!--@click="linkRecentUpdates" -->
        <!--<div class="recent-updates">
          <p ><a href="/static/Recent_update.pdf" target="_blank">Recent Updates</a></p>
        </div>-->
        <img class="portrait" :src="portrait">
        <el-dropdown id="dropdown" @command = "handleCommand">
          <span class="el-dropdown-link">
            <label>{{username}}<!--<span class="messageTip" v-show="messageTip"></span>--></label>
           <img class="patientList-drown" src="../../assets/arrow_down.png">
          </span>

          <el-dropdown-menu slot="dropdown" id="dropdown-menu">
            <!--<el-dropdown-item v-show="isHcp" command="messages">{{$t('messages')}}<span class="messageTip" v-show="messageTip"></span></el-dropdown-item>
            <el-dropdown-item v-show="!isHcp" command="connect">{{$t('connection')}}<span class="messageTip" v-show="messageTip"></span></el-dropdown-item>
            <el-dropdown-item command="profile">{{$t('profile')}}</el-dropdown-item>
            <el-dropdown-item command="changePassword">{{$t('changeP')}}</el-dropdown-item>-->
            <el-dropdown-item command="loginOut">{{$t('sign out')}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
  import auth from '../../auth/auth'
  export default {
    data(){
      return{
       isHcp:true,

      }
    },
    computed:{
      portrait(){
         return '/api/v2.0/person/'+parseInt(sessionStorage.getItem('uid'))+'/portrait'
      },
      username(){
        return sessionStorage.getItem('username');
      },
      messageTip(){
        let unRead = parseInt(this.$store.state.unRead);
        let tip = (unRead===0)?false:true;
        //console.log(unRead,tip);
        return tip;
      },
    },
    methods:{
        handleCommand(command){
            if(command==='loginOut'){
              sessionStorage.removeItem('token');
              this.$http.post('api/v2.0/logout').then(function(res){
                let err =res.body.error;
                if(err===0){
                  if (false){
                    if(sessionStorage.getItem('userType')==='P'||sessionStorage.getItem('userType')==='M'){
                      this.$router.push('/login');
                    }
                    if(sessionStorage.getItem('userType')==='D'){
                      this.$router.push('/hcpLogin');
                    }
                  }
                  if ('/CreateHCP'==this.$route.path) {
                    this.$router.push('/accountsmanagement');
                  //} else if ('/ClinicExportData'==this.$route.path) {
                  } else if ('/ClinicPatientList'==this.$route.path ||
                    '/ClinicExportData'==this.$route.path
                  ) {
                    this.$router.push('/clinic');
                  }

                  //清除session ，保存languages
                  let lang =  sessionStorage.getItem('language');
                  sessionStorage.clear();
                  sessionStorage.setItem('language',lang);
                }
              });
            }
           if(command==='connect'){
              this.$router.push('/connection');
           }
          if(command==='profile'){
            this.$router.push('/profile1');
          }
          if(command==='changePassword'){
            this.$router.push('/changePassword');
          }
          if(command==='messages'){
            this.$router.push('/messages');
          }

        },
        home(){
          let user = sessionStorage.getItem('userType');
          if(user==='P'){
              this.$router.push('/refresh')
          }
          if(user==='D'){
            this.$router.push('/ClinicPatientList');
          }
          if(user==='M'){ this.$router.push('/carerConnection');}
        },

        linkRecentUpdates () {
          //this.$router.push('/recent-updates')
        },
    },
    mounted(){
      this.isHcp =(sessionStorage.getItem('userType')==='P')?false:true;
      let uid = parseInt(sessionStorage.getItem('uid'));
      if(this.isHcp){
        auth.getUnread(this);
      }else{
        auth.getUnread1(this);
      }
    },
  }
</script>
<style scoped>
  #header{
    width:100%;
    height:60px;
    background-color: #fff;
    box-shadow:inset 0 -1px 0 0 #e6e6e6;
  }
  .header-content{
    width:60%;
    margin:0 auto;
  }
  @media screen and (max-width: 1500px){
    .header-content{
      width:90%;
      margin:0 auto;
    }
  }
  .patientList-logo{
    height:34px;
    width:84px;
    margin:14px 0 12px 40px;
    cursor: pointer;
  }
  .patientList-user{
    height:34px;
    float: right;
    margin:13px  43px 13px 0;
  }
  .recent-updates {
    float:left;
    margin-right:10px;
    margin-top:5px;
    color:#282828;
    border-right: solid 2px #282828;
    padding-right: 10px;
    font-family: SFUIText-Regular;
    font-size:16px;
  }
  .recent-updates p{
    cursor: pointer;
  }
  .portrait{
    width:34px;
    height:34px;
    float: left;
    border-radius:100%;
  }
  .messageTip{
    background: #ff0000;
    display: inline-block;
    height: 8px;
    width: 8px;
    border-radius: 8px;
    margin-bottom: 1px;
    margin-left: 5px;
  }
  #dropdown{
    float: right;
    cursor: pointer;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#0082d2;
    height: 40px;
    margin-right: 30px;
    margin-left: 20px;
  }
  #dropdown label{
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.39px;
    text-align:left;
    float: left;
    height:19px;
    padding:7px 30px 0 20px;
    padding-bottom: 20px;
    margin-left: -20px;
    display: inline-block;
    cursor: pointer;
  }
  .patientList-drown{
    float: right;
    display: inline-block;
    height:6px;
    width:17px;
    margin-top:15px;
    padding-bottom: 25px;
  }
  #dropdown-menu{
    color:#0082d2;
    font-family:SFUIText-Regular;
  }
</style>



// WEBPACK FOOTER //
// CreateHCPHeader.vue?06767919